import { useMutation } from '@apollo/client'

import { logActionMutation } from '../api/apollo/graphql/analytics-client'

export default function useLogAction() {
  const [logAction] = useMutation(logActionMutation)

  // Exclude logging on localhost staging override
  const isOverride =
    process.env.REACT_APP_STAGING_OVERRIDE === 'true' &&
    process.env.REACT_APP_NODE_ENV !== 'production'

  if (!isOverride) return logAction

  return async () => null
}
